import axios from "axios";

const findAddressIoClient = axios.create({
  baseURL: "https://findaddress.io",
  headers: {
    "x-api-key":
      "72e41ab4979010777cd1b842c5cbb6e314e5a4b764a8cf619d557f00705e5c46",
  },
});

type FindAddressApiResponse = {
  result: string;
  latitude: string;
  longitude: string;
  expandedAddress: {
    house: string;
    street: string;
    locality: string;
    town: string;
    district: string;
    county: string;
    pCode: string;
  };
};

export type FindAddressResult = {
  house: string;
  street: string;
  locality: string;
  town: string;
  county: string;
  postcode: string;
  latitude: number;
  longitude: number;
};

export const lookupAddress = async (
  houseNumber: string,
  postcode: string,
): Promise<FindAddressResult | null> => {
  const formattedPostcode = postcode.replace(/\s/g, "");

  try {
    const { data } = await findAddressIoClient.get<FindAddressApiResponse>(
      `/API/${encodeURIComponent(houseNumber)}/${formattedPostcode}`,
    );

    if (data.result !== "Success") {
      return null;
    }

    const lat = parseFloat(data.latitude);
    const lng = parseFloat(data.longitude);

    if (isNaN(lat) || isNaN(lng)) {
      return null;
    }

    return {
      house: data.expandedAddress.house,
      street: data.expandedAddress.street,
      locality: data.expandedAddress.locality,
      town: data.expandedAddress.town,
      county: data.expandedAddress.county,
      postcode: data.expandedAddress.pCode,
      latitude: lat,
      longitude: lng,
    };
  } catch {
    return null;
  }
};
